export const journey = [
  {
    period: "2025 — Present",
    title: "Master’s in Computer Science",
    org: "Graduate Studies",
    note: "Advanced computing, research methods and real-world problem solving alongside full-stack client work.",
    kind: "Education",
  },
  {
    period: "2025",
    title: "Software Development Internship",
    org: "Skymirror Inc.",
    note: "Six months of professional practice on real products — frontend systems, backend architecture and product-focused workflows.",
    kind: "Experience",
  },
  {
    period: "2024",
    title: "Full-Stack Web Development",
    org: "Professional Training Program",
    note: "End-to-end training across frontend, backend and database-driven applications.",
    kind: "Training",
  },
  {
    period: "2024",
    title: "Cyber Security Fundamentals",
    org: "ARRA Academy",
    note: "Web security threats, mitigations and the practices that keep applications safe.",
    kind: "Certificate",
  },
  {
    period: "2024",
    title: "UI/UX Design with Figma",
    org: "Design Training",
    note: "User-centred design, wireframing, prototyping and usability thinking.",
    kind: "Certificate",
  },
  {
    period: "2023",
    title: "Agile Basics & Scrum Foundations",
    org: "Agile Training",
    note: "Iterative delivery, team rituals and planning that survives contact with reality.",
    kind: "Certificate",
  },
  {
    period: "2021 — 2024",
    title: "BSc in Computer Science — Software Design",
    org: "University Degree",
    note: "Programming, software engineering principles, databases and system design.",
    kind: "Education",
  },
];
